/**
 * Stand-in for @ag-grid-enterprise/all-modules, which ag-Grid stopped publishing after v27.
 * tsconfig.json maps the old package name to this file, so existing imports keep working.
 * From ag-Grid 33 the grid ships as ag-grid-community / ag-grid-enterprise, and AllEnterpriseModule
 * holds every community and enterprise feature (integrated charts and sparklines need ag-charts and are not used).
 */
import { Module } from 'ag-grid-community';
import { AllEnterpriseModule } from 'ag-grid-enterprise';

export * from 'ag-grid-community';
export { LicenseManager } from 'ag-grid-enterprise';

// Keeps the v27 export name used across the app.
// eslint-disable-next-line @typescript-eslint/naming-convention
export const AllModules: Module[] = [AllEnterpriseModule];
